<app-view-trip-btn [trip]="data"></app-view-trip-btn>
